module.exports = __webpack_public_path__ + "img/bg_year.f8a8add1.png";